// extracted by mini-css-extract-plugin
export default {"header":"Header_header__0DjBk","header2":"Header_header2__lkTq5","logo":"Header_logo__pjupw","login":"Header_login__cTskk"};